import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const AgentBlocksTextContext = createContext(null);
/** Hands the host's translated words to every block below it. */
export function AgentBlocksTextProvider({ value, children }) {
    return _jsx(AgentBlocksTextContext.Provider, { value: value, children: children });
}
/**
 * Reads the words handed by the host. A block rendered without a provider is
 * a wiring mistake, not a state to degrade from, so it throws.
 */
export function useAgentBlocksTextContext() {
    const text = useContext(AgentBlocksTextContext);
    if (!text) {
        throw new Error('Agent blocks need an <AgentBlocksTextProvider> above them.');
    }
    return text;
}
